(function() {
    'use strict';

    var Pikaday = require('pikaday');
    var i18n = require('./pickaday-i18n');
    var leasePicker = require('./leasePicker');
    var utils = require('./utils');

    var lang = document.documentElement.lang;

    var datepickers = document.querySelectorAll('[datepicker="default"]');
    if (datepickers.length) {
        utils.forEach(datepickers, function (index, element) {
            new Pikaday({
                field: element,
                format: 'YYYY/MM/DD',
                i18n: lang === 'fr' ? i18n.fr : i18n.en
            });
        });
    }

    var leasePickers = document.querySelectorAll('[lease-picker="container"]');
    utils.forEach(leasePickers, function (index, element) {
        new leasePicker(element);
    });

})();

